/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsePhaseDto } from '../../models/response-phase-dto';

export interface PhasesControllerFindOne$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Phase unique ID
 */
  id: string;
}

export function phasesControllerFindOne(http: HttpClient, rootUrl: string, params: PhasesControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePhaseDto>> {
  const rb = new RequestBuilder(rootUrl, phasesControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePhaseDto>;
    })
  );
}

phasesControllerFindOne.PATH = '/thalea-pathways/phases/{tenant}/{id}';
